/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/context/MmuSkuList.ts
 * @Description:
 */
import { createContext, useContext } from 'react';

const ForwardRefContext = createContext(null);

const ForwardRefContextProvider = ({ value, children }) => {
  return <ForwardRefContext.Provider value={value}>{children}</ForwardRefContext.Provider>;
};

const useForwardRefContext = () => {
  const context = useContext(ForwardRefContext);
  if (context === undefined) {
    throw new Error('useForwardRefContext must be used within a MmuSkuListContextProvider');
  }
  return context;
};

export { ForwardRefContextProvider, useForwardRefContext };
